module.exports = "<div class=value-array> <component v-for=\"_nope in fragment\" :is=renderType[$index] :fragment.sync=fragment[$index] @splice=splice($index)></component> <button class=btn-add @click=push>Add</button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueArray.vue
 ** module id = 145
 ** module chunks = 0
 **/